import React from 'react';
import MarkdownPage from '../Components/InfoPages/MarkdownPage';

function PeoplePage() {
  return <MarkdownPage slug="cxb-people" titleKey="infoPages.cxbPeople.title" descriptionKey="infoPages.cxbPeople.description" />;
}

export default PeoplePage;
